import { render, staticRenderFns } from "./WithdrawalPointList.vue?vue&type=template&id=2e8909c1&scoped=true&"
import script from "./WithdrawalPointList.vue?vue&type=script&lang=js&"
export * from "./WithdrawalPointList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8909c1",
  null
  
)

export default component.exports